import styled from 'styled-components';

const Wrapper = styled.div<{ $open?: boolean; $disabled?: boolean }>`
    position: relative;
    z-index: 20;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
    cursor: ${({ $open, $disabled }) => {
        if ($disabled) {
            return 'default';
        }
        return $open ? 'default' : 'pointer';
    }};
    margin-left: 10px;
`;

export default Wrapper;
